module.exports = "<img [defaultImage]=\"defaultImage\" [lazyLoad]=\"src\" (onStateChange)=\"handler($event)\" [offset]=\"500\" [alt]=\"alt\">"